import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב למרחק",
    opening: localizedGenderNode(
      [
      "אני מכיר את הרגע הזה.",
      "אני יושב עם אנשים,",
      "ועדיין משהו בי נשאר בחוץ.",
      "אני מדבר.",
      "עונה.",
      "ולפעמים אני אפילו מחייך.",
      "אבל בפנים אני לא באמת נכנס.",
      "כאילו משהו בי נשאר סגור.",
      "ואני כבר עייף",
      "מלהיות קרוב רק מבחוץ."
    ],
      [
      "אני מכירה את הרגע הזה.",
      "אני יושבת עם אנשים,",
      "ועדיין משהו בי נשאר בחוץ.",
      "אני מדברת.",
      "עונה.",
      "ולפעמים אני אפילו מחייכת.",
      "אבל בפנים אני לא באמת נכנסת.",
      "כאילו משהו בי נשאר סגור.",
      "ואני כבר עייפה",
      "מלהיות קרובה רק מבחוץ."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "רגע.",
      "אני לא פותח הכול עכשיו.",
      "אני רק שם לב למרחק שאני מרגיש."
    ],
      [
      "רגע.",
      "אני לא פותח הכול עכשיו.",
      "אני רק שם לב למרחק שאני מרגיש."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I feel I'm with people, but not really with them?",
      "מה קורה בי ברגע שבו אני נסגר?",
      "מה הכי כואב לי במרחק הזה?"
    ],
      [
      "When do I feel I'm with people, but not really with them?",
      "מה קורה בי ברגע שבו אני נסגר?",
      "מה הכי כואב לי במרחק הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני נשאר עוד רגע עם התחושה הזאת בלי לברוח ממנה."
    ],
      [
      "היום אני נשאר עוד רגע עם התחושה הזאת בלי לברוח ממנה."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "להרגיש את הכאב שבחוץ",
    opening: localizedGenderNode(
      [
      "זה לא רק מרחק.",
      "יש בזה כאב.",
      "אני מרגיש אותו אחרי מפגש.",
      "כשהשיחה נגמרת.",
      "כשכולם ממשיכים הלאה.",
      "ומשהו בי נשאר ריק."
    ],
      [
      "זה לא רק מרחק.",
      "יש בזה כאב.",
      "אני מרגיש אותו אחרי מפגש.",
      "כשהשיחה נגמרת.",
      "כשכולם ממשיכים הלאה.",
      "ומשהו בי נשאר ריק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש איפה זה פוגש אותי בגוף.",
      "אולי בחזה.",
      "אולי בבטן."
    ],
      [
      "אני מרגיש איפה זה פוגש אותי בגוף.",
      "אולי בחזה.",
      "אולי בבטן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הכי דוקר בי כשאני מרגיש בחוץ?",
      "איזה רגע אחרון נשאר בי אחרי מפגש עם אנשים?",
      "מה אני אומר לעצמי ברגע הזה?"
    ],
      [
      "מה הכי דוקר בי כשאני מרגיש בחוץ?",
      "איזה רגע אחרון נשאר בי אחרי מפגש עם אנשים?",
      "מה אני אומר לעצמי ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני שם לב לרגע שבו השקט שאחרי פוגש אותי."
    ],
      [
      "היום אני שם לב לרגע שבו השקט שאחרי פוגש אותי."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "לפגוש את הרגע שבו אני נסגר",
    opening: localizedGenderNode(
      [
      "יש רגע מסוים שבו זה קורה.",
      "מישהו מתקרב קצת.",
      "והגוף שלי מיד הולך אחורה.",
      "לא תמיד רואים את זה עליי.",
      "אבל בפנים אני כבר סוגר.",
      "כבר מתרחק."
    ],
      [
      "יש רגע מסוים שבו זה קורה.",
      "מישהו מתקרב קצת.",
      "והגוף שלי מיד הולך אחורה.",
      "לא תמיד רואים את זה עליי.",
      "אבל בפנים אני כבר סוגר.",
      "כבר מתרחק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני לא מנסה לעצור את זה.",
      "אני רק רואה את הרגע שבו אני נסגר.",
      "הוא קורה מהר."
    ],
      [
      "אני לא מנסה לעצור את זה.",
      "אני רק רואה את הרגע שבו אני נסגר.",
      "הוא קורה מהר."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי בדיוק אני מרגיש שאני מתחיל להתרחק?",
      "מה בי נבהל כשמישהו מתקרב?",
      "מה אני לא רוצה להרגיש שם?"
    ],
      [
      "מתי בדיוק אני מרגיש שאני מתחיל להתרחק?",
      "מה בי נבהל כשמישהו מתקרב?",
      "מה אני לא רוצה להרגיש שם?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני עוצר לשנייה אחת כשאני מרגיש את הסגירה מתחילה."
    ],
      [
      "היום אני עוצר לשנייה אחת כשאני מרגיש את הסגירה מתחילה."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "לראות איך אני נשאר בחוץ",
    opening: localizedGenderNode(
      [
      "זה כבר לא נראה לי מקרי.",
      "יש לי דרך קבועה להישאר קצת בחוץ.",
      "אני מקשיב.",
      "מתעניין.",
      "אבל שומר את עצמי מאחור."
    ],
      [
      "זה כבר לא נראה לי מקרי.",
      "יש לי דרך קבועה להישאר קצת בחוץ.",
      "אני מקשיב.",
      "מתעניין.",
      "אבל שומר את עצמי מאחור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני רואה איך זה נהיה אוטומטי.",
      "כמעט בלי לחשוב.",
      "הגוף כבר יודע להתרחק."
    ],
      [
      "אני רואה איך זה נהיה אוטומטי.",
      "כמעט בלי לחשוב.",
      "הגוף כבר יודע להתרחק."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני שומר את עצמי בחוץ בלי להגיד את זה?",
      "מה אני עושה כדי לא להיחשף יותר מדי?",
      "איך זה מרגיש אחרי שאני שוב נשאר מאחור?"
    ],
      [
      "איך אני שומר את עצמי בחוץ בלי להגיד את זה?",
      "מה אני עושה כדי לא להיחשף יותר מדי?",
      "איך זה מרגיש אחרי שאני שוב נשאר מאחור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני שם לב למחווה אחת קטנה שבה אני מסתיר את עצמי."
    ],
      [
      "היום אני שם לב למחווה אחת קטנה שבה אני מסתיר את עצמי."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "לזהות את המסלול הישן",
    opening: localizedGenderNode(
      [
      "יש בי משפט ישן שמנהל את זה.",
      "אולי אף אחד לא באמת ירצה להכיר אותי עד הסוף.",
      "אולי עדיף להישאר שטחי.",
      "ולא להרגיש דחייה."
    ],
      [
      "יש בי משפט ישן שמנהל את זה.",
      "אולי אף אחד לא באמת ירצה להכיר אותי עד הסוף.",
      "אולי עדיף להישאר שטחי.",
      "ולא להרגיש דחייה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שומע את המשפט הזה בפנים.",
      "הוא לא חדש.",
      "אבל הוא עדיין חזק."
    ],
      [
      "אני שומע את המשפט הזה בפנים.",
      "הוא לא חדש.",
      "אבל הוא עדיין חזק."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה משפט ישן נפתח בי כשקשר מתחיל להעמיק?",
      "מאיפה אני מכיר אותו?",
      "כמה אני מאמין לו היום?"
    ],
      [
      "איזה משפט ישן נפתח בי כשקשר מתחיל להעמיק?",
      "מאיפה אני מכיר אותו?",
      "כמה אני מאמין לו היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני כותב לעצמי את המשפט הישן כמו שהוא."
    ],
      [
      "היום אני כותב לעצמי את המשפט הישן כמו שהוא."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "לגעת בפחד להיחשף",
    opening: localizedGenderNode(
      [
      "מאחורי המרחק הזה",
      "יש פחד.",
      "פחד שמישהו יראה משהו בי",
      "ואז יתרחק."
    ],
      [
      "מאחורי המרחק הזה",
      "יש פחד.",
      "פחד שמישהו יראה משהו בי",
      "ואז יתרחק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש את הפחד הזה בגוף.",
      "הוא מכווץ אותי מהר.",
      "אני לא בורח גם ממנו."
    ],
      [
      "אני מרגיש את הפחד הזה בגוף.",
      "הוא מכווץ אותי מהר.",
      "אני לא בורח גם ממנו."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מפחד שיראו בי אם אתקרב באמת?",
      "מה אני מפחד שיקרה אם אהיה יותר גלוי?",
      "איך הפחד הזה שומר אותי במרחק?"
    ],
      [
      "מה אני מפחד שיראו בי אם אתקרב באמת?",
      "מה אני מפחד שיקרה אם אהיה יותר גלוי?",
      "איך הפחד הזה שומר אותי במרחק?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני נושם נשימה אחת כשעולה בי פחד מקרבה."
    ],
      [
      "היום אני נושם נשימה אחת כשעולה בי פחד מקרבה."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "לשמוע מה אני מפחד שיראו",
    opening: localizedGenderNode(
      [
      "לפחד הזה יש קול ברור.",
      "הוא אומר לי לא להכביד.",
      "לא להיחשף.",
      "לא לבקש יותר מדי."
    ],
      [
      "לפחד הזה יש קול ברור.",
      "הוא אומר לי לא להכביד.",
      "לא להיחשף.",
      "לא לבקש יותר מדי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מקשיב לקול הזה.",
      "הוא נשמע כאילו הוא שומר עליי.",
      "אבל הוא גם מרחיק אותי."
    ],
      [
      "אני מקשיב לקול הזה.",
      "הוא נשמע כאילו הוא שומר עליי.",
      "אבל הוא גם מרחיק אותי."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הפחד הזה אומר לי על עצמי?",
      "מתי אני הכי מציית לו?",
      "מה אני מפסיד כשאני נותן לו לנהל אותי?"
    ],
      [
      "מה הפחד הזה אומר לי על עצמי?",
      "מתי אני הכי מציית לו?",
      "מה אני מפסיד כשאני נותן לו לנהל אותי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני שם לב למשפט שהפחד זורק לי ברגע אמת."
    ],
      [
      "היום אני שם לב למשפט שהפחד זורק לי ברגע אמת."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "לתת מקום לצורך בקרבה",
    opening: localizedGenderNode(
      [
      "מתחת לפחד",
      "יש גם צורך.",
      "צורך שמישהו יישאר.",
      "שמישהו באמת יראה.",
      "שמישהו לא ייבהל ממני."
    ],
      [
      "מתחת לפחד",
      "יש גם צורך.",
      "צורך שמישהו יישאר.",
      "שמישהו באמת יראה.",
      "שמישהו לא ייבהל ממני."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נותן לצורך הזה מקום.",
      "לא כדי למלא אותו עכשיו.",
      "רק כדי לא להדחיק אותו."
    ],
      [
      "אני נותן לצורך הזה מקום.",
      "לא כדי למלא אותו עכשיו.",
      "רק כדי לא להדחיק אותו."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני הכי רוצה להרגיש בתוך חברות אמיתית?",
      "מה אני מחפש בקשר עמוק ולא מקבל?",
      "מה בי עדיין מחכה שמישהו יישאר איתו?"
    ],
      [
      "מה אני הכי רוצה להרגיש בתוך חברות אמיתית?",
      "מה אני מחפש בקשר עמוק ולא מקבל?",
      "מה בי עדיין מחכה שמישהו יישאר איתו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני מודה ביני לביני כמה אני רוצה קירבה אמיתית."
    ],
      [
      "היום אני מודה ביני לביני כמה אני רוצה קירבה אמיתית."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "להודות כמה אני רוצה קשר",
    opening: localizedGenderNode(
      [
      "קשה לי להודות כמה אני רוצה את זה.",
      "לא רק אנשים סביבי.",
      "אלא קשר שמרגיש אמיתי.",
      "קשר שאפשר לנוח בו."
    ],
      [
      "קשה לי להודות כמה אני רוצה את זה.",
      "לא רק אנשים סביבי.",
      "אלא קשר שמרגיש אמיתי.",
      "קשר שאפשר לנוח בו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נשאר עם הרצון הזה.",
      "בלי לזלזל בו.",
      "בלי להקטין אותו."
    ],
      [
      "אני נשאר עם הרצון הזה.",
      "בלי לזלזל בו.",
      "בלי להקטין אותו."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה חסר לי היום בקשר אנושי אמיתי?",
      "איך אני מרגיש כשאני מנסה להעמיד פנים שלא אכפת לי?",
      "מה אני באמת מבקש בלב שלי?"
    ],
      [
      "מה חסר לי היום בקשר אנושי אמיתי?",
      "איך אני מרגיש כשאני מנסה להעמיד פנים שלא אכפת לי?",
      "מה אני באמת מבקש בלב שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני נותן לרצון הזה שם אחד פשוט."
    ],
      [
      "היום אני נותן לרצון הזה שם אחד פשוט."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "לרכך קצת את ההגנה",
    opening: localizedGenderNode(
      [
      "אולי אני לא חייב להיפתח בבת אחת.",
      "אולי מספיק צעד קטן.",
      "אולי קרבה לא מתחילה בקפיצה",
      "אלא ברגע אחד קצת יותר אמיתי."
    ],
      [
      "אולי אני לא חייב להיפתח בבת אחת.",
      "אולי מספיק צעד קטן.",
      "אולי קרבה לא מתחילה בקפיצה",
      "אלא ברגע אחד קצת יותר אמיתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך קצת את השמירה.",
      "לא מוריד הכול.",
      "רק נושם פחות חזק לתוך ההגנה."
    ],
      [
      "אני מרכך קצת את השמירה.",
      "לא מוריד הכול.",
      "רק נושם פחות חזק לתוך ההגנה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני יכול להרשות לעצמי להיות קצת יותר אמיתי?",
      "מה נראה לי צעד קטן שלא מציף אותי?",
      "מה בי נרגע כשאני לא דורש מעצמי הכול?"
    ],
      [
      "איפה אני יכול להרשות לעצמי להיות קצת יותר אמיתי?",
      "מה נראה לי צעד קטן שלא מציף אותי?",
      "מה בי נרגע כשאני לא דורש מעצמי הכול?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני בוחר רגע אחד קטן שבו אני פחות מסתיר את עצמי."
    ],
      [
      "היום אני בוחר רגע אחד קטן שבו אני פחות מסתיר את עצמי."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "להישאר נוכח גם בלי ודאות",
    opening: localizedGenderNode(
      [
      "אני לא באמת יודע איך יקבלו אותי.",
      "זאת האמת.",
      "ועדיין משהו בי רוצה להישאר נוכח",
      "גם בלי הביטחון הזה."
    ],
      [
      "אני לא באמת יודע איך יקבלו אותי.",
      "זאת האמת.",
      "ועדיין משהו בי רוצה להישאר נוכח",
      "גם בלי הביטחון הזה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש את חוסר הוודאות.",
      "הוא לא נעים.",
      "אבל אני נשאר כאן רגע."
    ],
      [
      "אני מרגיש את חוסר הוודאות.",
      "הוא לא נעים.",
      "אבל אני נשאר כאן רגע."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מרגיש כשאין לי ביטחון שיקבלו אותי?",
      "מה עוזר לי לא לברוח מיד?",
      "איזה חלק בי רוצה להישאר למרות הפחד?"
    ],
      [
      "איך אני מרגיש כשאין לי ביטחון שיקבלו אותי?",
      "מה עוזר לי לא לברוח מיד?",
      "איזה חלק בי רוצה להישאר למרות הפחד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני נשאר עוד נשימה אחת גם כשאין לי שליטה."
    ],
      [
      "היום אני נשאר עוד נשימה אחת גם כשאין לי שליטה."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לשחרר את המשפט הישן",
    opening: localizedGenderNode(
      [
      "יש משפט שאני סוחב כבר הרבה זמן.",
      "שאני יותר מדי.",
      "או לא מספיק.",
      "או שפשוט לא באמת ירצו אותי קרוב."
    ],
      [
      "יש משפט שאני סוחב כבר הרבה זמן.",
      "שאני יותר מדי.",
      "או לא מספיק.",
      "או שפשוט לא באמת ירצו אותי קרוב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מחזיק את המשפט הזה מולי.",
      "לא נלחם בו.",
      "רק רואה כמה זמן הוא חי בי."
    ],
      [
      "אני מחזיק את המשפט הזה מולי.",
      "לא נלחם בו.",
      "רק רואה כמה זמן הוא חי בי."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה משפט ישן עליי הגיע הזמן לשמוע כמו שהוא?",
      "מה הוא גרם לי לעשות בקשרים?",
      "מה בי מתעייף מלשאת אותו?"
    ],
      [
      "איזה משפט ישן עליי הגיע הזמן לשמוע כמו שהוא?",
      "מה הוא גרם לי לעשות בקשרים?",
      "מה בי מתעייף מלשאת אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני נותן למשפט הישן להישאר על הדף ולא רק בתוכי."
    ],
      [
      "היום אני נותן למשפט הישן להישאר על הדף ולא רק בתוכי."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לבחור צעד קטן של קירבה",
    opening: localizedGenderNode(
      [
      "משהו בי כבר רואה את זה אחרת.",
      "לא פתאום.",
      "אבל מספיק כדי לבחור צעד אחד אחר."
    ],
      [
      "משהו בי כבר רואה את זה אחרת.",
      "לא פתאום.",
      "אבל מספיק כדי לבחור צעד אחד אחר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני לא מחפש שינוי גדול.",
      "רק בחירה אחת קצת יותר קרובה.",
      "קצת יותר חיה."
    ],
      [
      "אני לא מחפש שינוי גדול.",
      "רק בחירה אחת קצת יותר קרובה.",
      "קצת יותר חיה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה צעד קטן של קירבה מרגיש אפשרי לי עכשיו?",
      "עם מי אני מרגיש הכי פחות צורך להסתתר?",
      "מה אני רוצה לנסות לעשות אחרת בפעם הבאה?"
    ],
      [
      "איזה צעד קטן של קירבה מרגיש אפשרי לי עכשיו?",
      "עם מי אני מרגיש הכי פחות צורך להסתתר?",
      "מה אני רוצה לנסות לעשות אחרת בפעם הבאה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני שומר לי משפט אחד אמיתי שאוכל להגיד כשיגיע רגע נכון."
    ],
      [
      "היום אני שומר לי משפט אחד אמיתי שאוכל להגיד כשיגיע רגע נכון."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "להמשיך מכאן קצת יותר פתוח",
    opening: localizedGenderNode(
      [
      "אני לא הופך פתאום לאדם אחר.",
      "אבל אני כבר מבין יותר טוב למה אני מתרחק.",
      "ואני קצת פחות לבד עם זה.",
      "יש בי יותר מקום לקירבה ממה שהיה לי."
    ],
      [
      "אני לא הופך פתאום לאדם אחר.",
      "אבל אני כבר מבין יותר טוב למה אני מתרחק.",
      "ואני קצת פחות לבד עם זה.",
      "יש בי יותר מקום לקירבה ממה שהיה לי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם את מה שכבר זז בי.",
      "לא סוגר את זה מיד.",
      "נותן לזה להישאר."
    ],
      [
      "אני נושם את מה שכבר זז בי.",
      "לא סוגר את זה מיד.",
      "נותן לזה להישאר."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני רוצה לזכור על עצמי מתוך המסע הזה?",
      "איך אני רוצה לחזור לעצמי כשאני שוב נסגר?",
      "מה אני רוצה לקחת איתי לקשר הבא שנבנה?"
    ],
      [
      "מה אני רוצה לזכור על עצמי מתוך המסע הזה?",
      "איך אני רוצה לחזור לעצמי כשאני שוב נסגר?",
      "מה אני רוצה לקחת איתי לקשר הבא שנבנה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "היום אני שומר בי רגע אחד של קירבה כמשהו שאפשר לחזור אליו."
    ],
      [
      "היום אני שומר בי רגע אחד של קירבה כמשהו שאפשר לחזור אליו."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נותן לזה עוד רגע קטן בפנים.",
      "היום אני נותן לזה עוד רגע קטן בפנים."
    ),
  },
].map(buildNormalizedDay);

export const difficultyFormingDeepFriendshipsBlueprintEn = buildNormalizedPilotBlueprint({
  id: "difficulty_forming_deep_friendships_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "difficulty_forming_deep_friendships",
  category: "loneliness_belonging",
  journeyName: {
    he: "קושי ליצור חברויות עמוקות",
    en: "Difficulty forming deep friendships",
    es: "Dificultad para crear amistades profundas",
  },
  days,
});

export default difficultyFormingDeepFriendshipsBlueprintEn;
